import React, { Component } from 'react';
import './scss/Navbar.css';
import logo from './logo.png';
import { Link } from 'react-router-dom';

class Navbar extends Component {
    render() {
        return (
            <div>
                <nav className="navbar sticky-top  navbar-expand-lg navbar-light">
	  <a className="navbar-brand" href="#">
	  <img src={logo}  alt="..."/> </a>
	  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
		<span className="navbar-toggler-icon"></span>
	  </button>
	  <div className="collapse navbar-collapse" id="navbarNavDropdown">
		<ul className="navbar-nav">
		  <li className="nav-item mr-7 ml-7 ">
			<Link to="/" className="nav-linkbar" >Home</Link>
		  </li>
		  <li className="nav-item">
			<Link to="/about" className="nav-linkbar">About Us</Link>
		  </li>
		  {/* <li className="nav-item">
			<Link to="/ridewithygc" className="nav-linkbar">Ride With YGC</Link>
		  </li> */}
		  <li className="nav-item">
			<Link to="/services" className="nav-linkbar" >Services</Link>
		  </li>
		  <li className="nav-item">
			<Link to="/partner" className="nav-linkbar" >Partner</Link>
		  </li>
		  <li className="nav-item">
			<Link to="/contact" className="nav-linkbar" >Contact</Link>
		  </li>

		  {/* <li className="nav-item dropdown">
			<a className="nav-linkbar dropdown-toggle" href="#" id="navbarDropdownMenuLink" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			  Join Us
			</a>
			<div className="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
			  <Link to="/partner" className="dropdown-item" >Partner</Link>
			  <a className="dropdown-item" href="#">Career</a>
			  <a className="dropdown-item" href="#">Franchise</a>
			  
			</div>
		  </li> */}
		</ul>
		<div className="tansport ml-10 mr-3 ">
		  <p>
		  <img src="https://omlogistics.co.in/wp-content/themes/transport/assets/images/iphone.png"></img>
		  Call us now 
		  for transport |
		  <a href="tel:9813464620">9813464620</a>
		  </p>
		</div>  
		  
	</div>
</nav>
            </div>
        )
    }
}

export default Navbar
